import { request } from './client';
import type {
  Chapter,
  ChapterContent,
  ChapterNav,
  PaginatedResponse,
  UserReadingProgress,
} from '../types';

export const chapterApi = {
  /**
   * Get chapters for a novel (paginated)
   */
  list(
    novelId: string,
    page: number = 1,
    limit: number = 50
  ): Promise<PaginatedResponse<Chapter>> {
    return request<PaginatedResponse<Chapter>>(
      `/novels/${novelId}/chapters?page=${page}&limit=${limit}`
    );
  },

  /**
   * Get ALL chapters for a novel (auto-paginate)
   */
  async listAll(novelId: string): Promise<Chapter[]> {
    const pageSize = 500;
    let page = 1;
    const allChapters: Chapter[] = [];

    while (true) {
      const data = await request<PaginatedResponse<Chapter>>(
        `/novels/${novelId}/chapters?page=${page}&limit=${pageSize}`
      );
      allChapters.push(...data.chapters);
      if (page >= data.pagination.totalPages) break;
      page++;
    }

    return allChapters;
  },

  /**
   * Get chapter content
   */
  get(id: string): Promise<ChapterContent> {
    return request<ChapterContent>(`/chapters/${id}`);
  },

  /**
   * Mark chapter as read
   */
  markRead(id: string): Promise<UserReadingProgress> {
    return request<UserReadingProgress>(`/chapters/${id}/read`, { method: 'POST' });
  },

  /**
   * Get chapter navigation (prev/next)
   */
  getNav(id: string): Promise<ChapterNav> {
    return request<ChapterNav>(`/chapters/${id}/nav`);
  },
};
